import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import React from 'react';
import {Box, ResultSubject, Text} from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import EntityIcon from '../../../../components/EntityIcon/EntityIcon';

const GDrive = ({ item, isPreview }: any) => {
  const files = [{...item}];
  let ownership = `Owned by ${item.ownedByMe ? item.gdrive_account : item.owners[0]?.emailAddress}`;
  if (item.shared) {
    let sharingUser;
    let lastEdit;
    if (item.sharingUser && item.sharingUser.emailAddress) {
      sharingUser = item.sharingUser.emailAddress;
    }
    if (item.lastModifyingUser && item.lastModifyingUser.emailAddress) {
      lastEdit = item.lastModifyingUser.emailAddress;
    }
    if (sharingUser) {
      ownership = `Shared by ${sharingUser}`;
    }
    if (lastEdit) {
      ownership = `${ownership} | Last edited by ${lastEdit}`
    }
  }
  if (isPreview) {
    return (
      <Box display="flex" flexDirection="column" overflow="auto">
        <Box display="flex" alignItems="center">
          <Box mr={20}>
            <EntityIcon entityName={item.pl} />
          </Box>
          <ResultSubject>
            <HighlightMarker>
              {item.title}
            </HighlightMarker>
          </ResultSubject>
        </Box>
        <Box mt={40} ml={[0, 60]}>
          <FileAttachments files={files} />
          <Text variant="muted" size="small">
            {ownership} | {item.date}
          </Text>
        </Box>
      </Box>
    )
  }
  return (
    <>
      <ResultSubject>
        <HighlightMarker>
          {item.title}
        </HighlightMarker>
      </ResultSubject>
      <FileAttachments files={files} />
      <Text variant="muted" size="small">
        {ownership} | {item.date}
      </Text>
    </>
  )
}

export default GDrive;